import { SxProps } from '@mui/material';

import { themeColors } from '@/config/theme/themeColors.ts';

export const EmailAttachmentsItemTextStyles: SxProps = {
  py: 0.5,
};

export const EmailAttachmentsDividerStyles: SxProps = {
  borderColor: themeColors.grey,
  height: '100%',
  ml: 2,
  my: 0,
  py: 2,
};

export const EmailAttachmentsItemStyles = (params: { isReady: boolean }): SxProps => {
  const { isReady } = params;
  return {
    '&:hover': {
      boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.1)',
    },
    border: `1px solid ${themeColors.grey}`,
    borderRadius: '5px',
    cursor: isReady ? 'default' : 'not-allowed',
    pl: 2,
  };
};

export const EmailAttachmentsIconWrapperStyles = (params: { isReady: boolean }): SxProps => {
  const { isReady } = params;
  return {
    '&:hover': {
      backgroundColor: isReady ? 'rgba(182,182,182,0.3)' : 'none',
    },
    alignItems: 'center',
    cursor: isReady ? 'pointer' : 'not-allowed',
    display: 'flex',
    height: '100%',
    px: 1,
  };
};
